import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtochikolitaxi() {



    const cardData = {




keyword: "Belgaum to Chikodi Taxi",

headingDescription: "Belgaum Taxi Service offers comfortable and reliable Belgaum to Chikodi taxi services for local travel, business visits, family trips, shopping, educational purposes, and daily transportation needs. Whether you need a one-way taxi or a round-trip cab from Belgaum to Chikodi, we provide safe and convenient travel with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options according to your requirements. Our services include doorstep pickup, flexible travel schedules, transparent pricing, easy booking, and 24/7 customer support for a smooth journey. Belgaum Taxi Service provides hassle-free connectivity between Belgaum and Chikodi for individuals, families, and business travelers looking for affordable and comfortable taxi solutions.",

topPlaces: [
  {
    title: "Chikodi",
    description: "Chikodi is an important town near Belgaum known for agriculture, education, local markets, and commercial activities. It is a frequently traveled destination from Belgaum."
  },
  {
    title: "Nipani",
    description: "Nipani is a nearby commercial town located close to Chikodi, known for trade, markets, and connectivity between Karnataka and Maharashtra."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a major city near Chikodi famous for Mahalaxmi Temple, shopping, business activities, and cultural heritage."
  },
  {
    title: "Belagavi Airport",
    description: "Belagavi Airport provides air connectivity for travelers from nearby towns. Taxi services offer convenient airport pickup and drop facilities from Chikodi and surrounding areas."
  },
  {
    title: "Gokak",
    description: "Gokak is known for Gokak Falls, historical attractions, and scenic landscapes, making it a popular short-distance destination from Belgaum and Chikodi."
  },
  {
    title: "Sankeshwar",
    description: "Sankeshwar is a growing commercial town near Chikodi and Belgaum, known for industries, markets, and business activities."
  },
  {
    title: "Goa",
    description: "Goa is a popular tourist destination known for beaches, resorts, churches, and sightseeing attractions. Private taxis provide comfortable travel for holiday trips."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial hub in Maharashtra. Travelers prefer private cabs for business trips and interstate journeys."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital with business districts, airports, and tourist attractions. Comfortable taxi services provide convenient long-distance connectivity."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a nature and adventure destination famous for wildlife, forests, river rafting, and outdoor activities, making it a popular getaway location."
  }
],




"services": [
  {
    "name": "Belgaum to Chikodi Taxi",
    "description": "Book Belgaum to Chikodi Taxi for safe, comfortable, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Get convenient taxi services for local visits, business travel, family trips, and regular transportation needs with flexible booking options."
  },
  {
    "name": "Belgaum to Chikodi Cab",
    "description": "Hire Belgaum to Chikodi Cab for affordable and hassle-free travel between both locations. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs with experienced drivers, clean interiors, and comfortable seating."
  },
  {
    "name": "Belgaum to Chikodi Taxi Service",
    "description": "Choose Belgaum to Chikodi Taxi Service for dependable transportation with doorstep pickup, transparent pricing, and professional drivers. Enjoy smooth journeys for personal, corporate, and family travel requirements."
  },
  {
    "name": "Belgaum to Chikodi Cab Service",
    "description": "Book Belgaum to Chikodi Cab Service for reliable intercity travel with premium vehicles and trained chauffeurs. Our cab services provide comfortable rides for one way trips, round trips, and customized travel plans."
  },
  {
    "name": "Belgaum to Chikodi One Way Cab",
    "description": "Reserve Belgaum to Chikodi One Way Cab for economical point-to-point transportation without return charges. Enjoy fixed pricing, comfortable AC vehicles, and professional driver assistance."
  },
  {
    "name": "Belgaum to Chikodi One Way Taxi",
    "description": "Choose Belgaum to Chikodi One Way Taxi for budget-friendly single destination travel. Get reliable pickup services, clean cars, and experienced chauffeurs for a smooth journey."
  },
  {
    "name": "Belgaum to Chikodi Cab Booking",
    "description": "Complete Belgaum to Chikodi Cab Booking with easy online reservations and quick confirmation. Select your preferred vehicle category according to passenger count, luggage, and travel requirements."
  },
  {
    "name": "Belgaum to Chikodi Taxi Booking",
    "description": "Book Belgaum to Chikodi Taxi Booking services for comfortable and convenient travel. Enjoy affordable fares, professional drivers, and well-maintained vehicles for every journey."
  },
  {
    "name": "Belgaum to Chikodi Car Rental",
    "description": "Choose Belgaum to Chikodi Car Rental with driver for flexible transportation solutions. Hire comfortable cars for family visits, business trips, sightseeing, and personal travel."
  },
  {
    "name": "Belgaum to Chikodi Outstation Cab",
    "description": "Travel with Belgaum to Chikodi Outstation Cab services offering safe and comfortable intercity transportation. Get experienced chauffeurs, AC vehicles, and flexible one way or round trip options."
  },
  {
    "name": "Belgaum to Chikodi Innova Crysta Cab",
    "description": "Book Belgaum to Chikodi Innova Crysta Cab for premium and spacious travel. Enjoy luxury seating, extra luggage space, and comfortable journeys for families, groups, and corporate passengers."
  },
  {
    "name": "Belgaum to Chikodi Ertiga Cab",
    "description": "Hire Belgaum to Chikodi Ertiga Cab for affordable 6 to 7 seater travel. Ertiga cabs are ideal for family trips, group travel, airport transfers, and outstation journeys."
  },
  {
    "name": "Belgaum to Chikodi Sedan Cab",
    "description": "Book Belgaum to Chikodi Sedan Cab for economical and comfortable transportation. Travel in clean AC sedans with professional drivers suitable for business and personal journeys."
  },
  {
    "name": "Belgaum to Chikodi Round Trip Cab",
    "description": "Reserve Belgaum to Chikodi Round Trip Cab for convenient return travel with affordable packages. Perfect for family visits, business requirements, and planned local tours."
  },
  {
    "name": "Belgaum to Chikodi Private Taxi",
    "description": "Choose Belgaum to Chikodi Private Taxi for personalized travel with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and flexible travel schedules."
  },
  {
    "name": "Cheap Belgaum to Chikodi Taxi",
    "description": "Find Cheap Belgaum to Chikodi Taxi services with affordable fares and quality vehicles. Travel safely with experienced drivers without compromising comfort and reliability."
  },
  {
    "name": "Best Belgaum to Chikodi Taxi Service",
    "description": "Select the Best Belgaum to Chikodi Taxi Service with premium vehicles, trained chauffeurs, and competitive pricing. Get reliable transportation solutions for families, businesses, and individuals."
  },
  {
    "name": "Online Belgaum to Chikodi Cab Booking",
    "description": "Book Online Belgaum to Chikodi Cab Booking services with easy reservations and instant confirmation. Choose from multiple cab options for comfortable and convenient travel."
  },
  {
    "name": "Belgaum to Chikodi Taxi Fare",
    "description": "Get affordable Belgaum to Chikodi Taxi Fare with transparent pricing and flexible packages. Select suitable vehicle options based on your travel needs and budget."
  },
  {
    "name": "Belgaum to Chikodi Car Hire",
    "description": "Hire Belgaum to Chikodi Car Hire services with reliable vehicles and professional drivers. Suitable for family travel, corporate visits, sightseeing, and personal transportation."
  },
  {
    "name": "Belgaum to Chikodi Cab Price",
    "description": "Check Belgaum to Chikodi Cab Price and choose affordable travel options. Get comfortable AC cabs with flexible booking facilities for one way and round trip journeys."
  },
  {
    "name": "Belgaum to Chikodi Chauffeur Service",
    "description": "Experience Belgaum to Chikodi Chauffeur Service with skilled drivers and premium vehicles. Enjoy safe, relaxed, and convenient travel with professional chauffeur assistance."
  },
  {
    "name": "Belgaum to Chikodi Family Cab",
    "description": "Book Belgaum to Chikodi Family Cab for safe and spacious travel. Enjoy comfortable seating, reliable drivers, and convenient transportation for family trips and personal visits."
  },
  {
    "name": "Belgaum to Chikodi Airport Transfer",
    "description": "Choose Belgaum to Chikodi Airport Transfer service for timely pickup and drop facilities. Travel comfortably with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Belgaum to Chikodi Cab Fare",
    "description": "Get details about Belgaum to Chikodi Cab Fare with affordable rates and multiple vehicle choices. Book Sedan, Ertiga, Innova Crysta, or SUV cabs according to your requirements."
  },
  {
    "name": "Belgaum to Chikodi Taxi Near Me",
    "description": "Find Belgaum to Chikodi Taxi Near Me for quick and reliable taxi availability. Book comfortable cabs with experienced drivers for safe and convenient travel."
  },
  {
    "name": "Belgaum to Chikodi Outstation Taxi",
    "description": "Hire Belgaum to Chikodi Outstation Taxi for comfortable long-distance travel with clean vehicles and professional chauffeurs. Enjoy reliable transportation for personal, family, and business journeys."
  },
  {
    "name": "Belgaum to Chikodi Travel by Cab",
    "description": "Travel from Belgaum to Chikodi by Cab with convenient booking options, comfortable vehicles, and experienced drivers. Enjoy smooth and stress-free transportation for your complete journey."
  }
],
"tableData": [
  ["Belgaum to Chikodi Taxi", "Belgaum to Chikodi Cab"],
  ["Belgaum to Chikodi Taxi Service", "Belgaum to Chikodi Cab Service"],
  ["Belgaum to Chikodi One Way Cab", "Belgaum to Chikodi One Way Taxi"],
  ["Belgaum to Chikodi Cab Booking", "Belgaum to Chikodi Taxi Booking"],
  ["Belgaum to Chikodi Car Rental", "Belgaum to Chikodi Outstation Cab"],
  ["Belgaum to Chikodi Innova Crysta Cab", "Belgaum to Chikodi Ertiga Cab"],
  ["Belgaum to Chikodi Sedan Cab", "Belgaum to Chikodi Round Trip Cab"],
  ["Belgaum to Chikodi Private Taxi", "Cheap Belgaum to Chikodi Taxi"],
  ["Best Belgaum to Chikodi Taxi Service", "Online Belgaum to Chikodi Cab Booking"],
  ["Belgaum to Chikodi Taxi Fare", "Belgaum to Chikodi Car Hire"],
  ["Belgaum to Chikodi Cab Price", "Belgaum to Chikodi Chauffeur Service"],
  ["Belgaum to Chikodi Family Cab", "Belgaum to Chikodi Airport Transfer"],
  ["Belgaum to Chikodi Cab Fare", "Belgaum to Chikodi Taxi Near Me"],
  ["Belgaum to Chikodi Outstation Taxi", "Belgaum to Chikodi Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Chikodi Taxi Service",
    WhyChoosedescription: "Travel conveniently from Belgaum to Chikodi with a trusted taxi service offering comfortable vehicles, professional drivers, and flexible options for smooth local and intercity travel."
  },
  {
    WhyChooseheading: "Easy Pickup & Drop Facility",
    WhyChoosedescription: "Get convenient taxi pickup from homes, offices, hotels, railway station, airport areas, and other locations in Belgaum with direct drop in Chikodi."
  },
  {
    WhyChooseheading: "Multiple Cars for Your Journey",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs depending on your comfort, passenger count, and luggage requirements."
  },
  {
    WhyChooseheading: "Ideal for Short & Personal Trips",
    WhyChoosedescription: "Our Belgaum to Chikodi taxis are suitable for family visits, business work, medical travel, shopping trips, and regular transportation needs."
  },
  {
    WhyChooseheading: "Experienced Drivers on the Route",
    WhyChoosedescription: "Skilled chauffeurs ensure timely arrival, safe driving, and a comfortable journey with good knowledge of the Belgaum to Chikodi route."
  },
  {
    WhyChooseheading: "Flexible Travel Choices",
    WhyChoosedescription: "Select a one-way taxi for direct travel or plan a return trip according to your preferred schedule and requirements."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Cabs",
    WhyChoosedescription: "Enjoy a pleasant ride with hygienic interiors, properly serviced vehicles, and comfortable seating throughout your journey."
  },
  {
    WhyChooseheading: "Quick Cab Booking Assistance",
    WhyChoosedescription: "Get support for vehicle availability, fare details, and taxi reservations for your Belgaum to Chikodi travel needs."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Chikodi Taxi Service?",
    answer: "Yes, we provide Belgaum to Chikodi taxi services with comfortable vehicles and professional drivers."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Chikodi?",
    answer: "Yes, one-way cab services are available for passengers who need direct travel between Belgaum and Chikodi."
  },
  {
    question: "Which vehicles are available for Belgaum to Chikodi travel?",
    answer: "We offer Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs based on your travel needs."
  },
  {
    question: "Is this taxi service suitable for family travel?",
    answer: "Yes, comfortable vehicles with spacious seating are available for families and small groups travelling between Belgaum and Chikodi."
  },
  {
    question: "Can I book a return cab from Chikodi to Belgaum?",
    answer: "Yes, return journey taxi options are available with flexible timings according to your convenience."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop services are available from Belgaum Airport, Railway Station, hotels, and preferred locations."
  },
  {
    question: "Can I hire a private taxi from Belgaum to Chikodi?",
    answer: "Yes, private taxi services are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll charges, parking fees, and additional costs depend on the selected travel package and are communicated during booking."
  },
  {
    question: "Is Belgaum to Chikodi taxi service available 24/7?",
    answer: "Yes, taxi booking assistance is available for planned travel and urgent transportation requirements."
  },
  {
    question: "How can I book a Belgaum to Chikodi Taxi?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Santosh Kulkarni",
    feedback: "The Belgaum to Chikodi taxi service was very convenient. The driver arrived on time, and the overall journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Patil",
    feedback: "Excellent cab experience with a clean vehicle and professional driver. The service made our travel between Belgaum and Chikodi easy.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Chikodi Taxi",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-chikodi-taxi.webp",
  "description":
    "Book Belgaum to Chikodi Taxi with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Chikodi with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, business trips, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-chikodi-taxi"
  }
};




    return (
        <div>

<Helmet>
  <title>Belgaum to Chikodi Taxi | One Way Cab Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Chikodi Taxi with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Chikodi with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable local and outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Chikodi Taxi, Belgaum to Chikodi Cab, Belgaum to Chikodi Taxi Service, Belgaum to Chikodi Cab Service, Belgaum to Chikodi One Way Cab, Belgaum to Chikodi Taxi Booking, Belgaum to Chikodi Car Rental, Belgaum to Chikodi Outstation Taxi, Belgaum to Chikodi Taxi Fare"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtochikolitaxi;